<template>
	<div class="products-list">
		<h3>Export Products</h3>

		<div class="productExport">
			<div v-if="brands">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand (Optional)"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
					v-on:keyup.enter="getProducts"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div @click="getProducts" class="button">
				Export
			</div>
		</div>

		<div v-if="progress > 0" class="progress-bar">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'productsList',
	data: function() {
		return {
			limit: this.$config.pageItemsLimit,
			brands: [],
			selectedBrand: null,
			brandSuggestions: '',
			products: [],
			progress: 0
		}
	},

	mounted: async function() {
		this.getBrands()
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		getProducts: async function() {
			this.products = []
			this.progress = 0
			var totalLoop = 0

			var apiGetProducts = await this.getProductsLoop(0)

			if (apiGetProducts && apiGetProducts.total) {
				apiGetProducts.list.map(product => {
					this.products.push(product)
				})

				totalLoop = Math.ceil(apiGetProducts.total / this.limit)
				var i

				for (i = 1; i < totalLoop; i++) {
					let skip = i * this.limit

					this.progress = (skip / apiGetProducts.total) * 100

					var apiProducts = await this.getProductsLoop(skip)

					apiProducts.list.map(product => {
						this.products.push(product)
					})
				}

				this.progress = 100

				if (this.products && this.products.length > 0) {
					let csv =
						'BD CODE,PRODUCT NAME,BRAND NAME,BRAND CODE,BARCODE,PRICE,STOCK,ORIGINAL_PRICE_UNIT,PACKAGING_BASE_UNIT,BOX_PRICE,BOX_CARDS,CARD_PRICE,CARD_PILLS,PILL_PRICE,PACKAGING_BREAKDOWN_BOX,PACKAGING_BREAKDOWN_CARD,PACKAGING_BREAKDOWN_PILL\r\n'

					this.products.map(product => {
						// Helper function to safely get packaging values
						const getPackagingValue = path => {
							try {
								return path || ''
							} catch (e) {
								return ''
							}
						}

						// Extract packaging data safely
						const packaging = product.packaging || {}
						const packagingBreakdown = product.packaging_breakdown || {}

						const toAdd = [
							product.bd_code,
							'"' + product.name + '"',
							'"' + product.brand.name + '"',
							product.brand.code,
							'"' + product.barcode + '"',
							product.price,
							product.stock,
							// New fields
							getPackagingValue(product.original_price_unit),
							getPackagingValue(packaging.base_unit),
							getPackagingValue(packaging.box?.price),
							getPackagingValue(packaging.box?.cards),
							getPackagingValue(packaging.card?.price),
							getPackagingValue(packaging.card?.pills),
							getPackagingValue(packaging.pill?.price),
							getPackagingValue(packagingBreakdown.box),
							getPackagingValue(packagingBreakdown.card),
							getPackagingValue(packagingBreakdown.pill)
						]

						let row = toAdd.join(',')

						csv += row + '\r\n'
					})

					const todayDate = this.$moment(this.date).format('DD-MM-YY')

					var filename = ''

					if (this.selectedBrand && this.selectedBrand.code) {
						filename = this.selectedBrand.code + '-' + todayDate + '-products-export.csv'
					} else {
						filename = todayDate + '-products-export.csv'
					}

					var csvData = new Blob([csv], { type: 'text/csv' }) //new way
					var csvUrl = URL.createObjectURL(csvData)

					var link = document.createElement('a')
					link.setAttribute('href', csvUrl)
					link.setAttribute('download', filename)
					document.body.appendChild(link) // Required for FF

					this.isLoading = false

					link.click()
					link.remove()

					this.isLoading = false
				}
			} else {
				this.$swal.fire({
					icon: 'error',
					title: 'No data',
					text: 'No data found!'
				})
			}
		},

		getProductsLoop: async function(skip = 0) {
			var data = {
				limit: this.limit,
				skip,
				populate: ['brand'],
				sort: {
					stock: 'asc'
				}
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.brand = this.selectedBrand._id
			}

			var apiGetProducts = await this.$api.searchProduct({ data })

			if (apiGetProducts) {
				return apiGetProducts.data
			}
		},

		getBrands: async function() {
			const brands = await this.$api.getBrandList()

			if (brands) {
				this.brands = brands.data.list
			}
		}
	}
}
</script>

<style scoped>
@import '../styles/ProductsList.css';
</style>
